<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.firstTitle
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="banner">
                <div class="left">
                    <dl>
                        <dt><img src="@/assets/images/realName/ent1.png" alt=""></dt>
                        <dd>
                            <h4>企业实名认证</h4>
                            <p>完成实名认证，使用平台相关功能</p>
                        </dd>
                    </dl>
                </div>
                <div class="right">
                    <img src="@/assets/images/realName/ent2.png" alt="">
                </div>
            </div>
            <div class="cnt">
                <h5>请根据要求完成认证</h5>
                <div class="flexRow">
                    <div class="solid"></div>
                    <div :class="status==0?'one':'two'" style="flex:3;">
                        <div class="title">
                            <img v-if="status==0" src="@/assets/images/realName/radio_active.png" alt="">
                            <img v-else src="@/assets/images/realName/radio_disable.png" alt="">
                            <h6>信息提交</h6>
                        </div>
                        <div class="introduce">
                            需准备营业执照照片
                        </div>
                    </div>
                    <div :class="status!==0?'one':'two'" style="flex:3.5;">
                        <div class="title">
                            <img v-if="status!==0" src="@/assets/images/realName/radio_active.png" alt="">
                            <img v-else src="@/assets/images/realName/radio_disable.png" alt="">
                            <h6>信息认证</h6>
                        </div>
                        <div class="introduce">
                            <div class="way"><span>方式一：</span><span>法定代表人认证</span></div>
                            <div class="way"><span>方式二：</span><span>下载《企业授权书》，线下盖章且需对公 账户打款</span></div>
                        </div>
                    </div>
                </div>
                <div class="btns">
                    <span class="primary" @click="start">开始认证</span>
                    <span class="quit" @click="quit">退出认证</span>
                </div>
            </div>
        </div>
    </el-row>
</template>

<script>
import { identification } from "@http/user_center/userInfo";
export default {
    data() {
        return {
            status: 0,
        };
    },

    components: {},

    computed: {},

    created() {
        this.init()
    },

    mounted() {},

    methods: {
        async init(){
            let {authenticationStatus}=await identification();
            this.status=authenticationStatus;
        },
        start(){
            if(this.status==-1){
                //未认证去识别企业信息页
                this.$router.push({
                    path:'/userCenter/realName/enterpriseInfo'
                })
            }else if(this.status==4){
                //企业信息已识别，直接选择授权方式
                this.$router.push({
                    path:'/userCenter/realName/enterpriseAuthorize'
                })
            }else if(this.status==6){
                //线下授权书申请审核中，去对公打款页
                this.$router.replace({
                    path:'/userCenter/realName/enterpriseResult'
                })
            }else if(this.status==9){
                //企业法人已认证，但是没签署授权书
                this.$router.push({
                    path:'/userCenter/realName/enterpriseSign'
                })
            }else if(this.status==10 || this.status==7){
                //已完成认证
                this.$router.replace({
                    path:'/userCenter/realName/enterpriseSuccess'
                })
                //this.$msg('您的企业认证已完成','success');
            }
        },
        quit(){
            if(this.$getlocalStorage("queryData")?.from=='lawcase'){
                window.location.href =`${process.env.VUE_APP_LAWCASE}/lawyer`
                return;
            }
            if(window.opener){
                window.opener = null;
                window.open('', '_self');
                window.close();
            }else{
                this.$router.replace({
                    path:'/Home'
                })
            }
        }
    },
};
</script>
<style lang="less" scoped>
.banner{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #10A0E9;
    padding:32px 10px 32px 35px;
    width: 800px;
    box-sizing: border-box;
    margin:0 auto;
    margin-top: 46px;
    .left{
        dl{
            color: #fff;
            display: flex;
            dt{
                margin-right: 17px;
                img{
                    width: 78px;
                    height: 78px;
                }
            }
            dd{
                padding-top:6px;
                h4{
                    font-size: 18px;
                    margin-bottom: 18px;
                }
                p{
                    font-size: 14px;
                    color: #CBEEFF;
                }
            }
        }
    }
}
.cnt{
    width: 800px;
    margin:0 auto;
    h5{
        font-size: 18px;
        color: #333;
        margin: 19px 0 28px;
    }
    .title{
        h6{
            font-size: 16px;
            margin: 14px 0;
        }
        img{
            width: 14px;
            height: 14px;
        }
    }
    .introduce{
        margin-top: 14px;
        font-size: 14px;
    }
    .flexRow{
        display: flex;
        position: relative;
        .solid{
            height: 0px;
            border:1px dashed #D1D1D1;
            width: 300px;
            position: absolute;
            left: 40px;
            top: 7px;
        }
        .one{
            color: #333;
            margin-bottom: 148px;
            .introduce{
                color: #6A7588;
                .way{
                    margin-bottom: 14px;
                }
            }
        }
        .two{
            color: #999;
            .introduce{
                color: #999;
                .way{
                    margin-bottom: 14px;
                }
            }
        }
    }
    .btns{
        margin-top: 40px;
        padding:0 30px;
        span{
            display: inline-block;
            width: 130px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            color: #10A0E9;
            font-size: 16px;
            border-radius: 5px;
            border:1px solid #10A0E9;
            cursor: pointer;
        }
        .primary{
            background:#10A0E9;
            color: #fff;
            margin-bottom: 20px;
            margin-right: 50px;
            opacity: .7;
            &:hover{
                opacity: 1;
            }
        }
        .quit{
            color:#10A0E9;
            &:hover{
                background: #10a1e91d;
            }
        }
    }
    
}
</style>
